interface LoginErrorScreenProps {
  onLogin: () => void;
}

export function LoginErrorScreen({ onLogin }: LoginErrorScreenProps) {
  return (
    <div
      className="fixed inset-0 z-[999999] flex items-center justify-center min-h-screen"
      style={{
        backgroundColor: "#F3F4F6",
        backgroundImage: `
          linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)),
          url('/login-bg.png'),
          url('/left-gradient.png'),
          url('/right-gradient.png')
        `,
        backgroundSize: "cover, cover, contain, 50%",
        backgroundPosition: "center, center, left bottom, top right",
        backgroundRepeat: "no-repeat",
        fontFamily:
          "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
      }}
    >
      <div className="flex flex-col items-center gap-36 w-full max-w-[400px] mx-4">
        {/* Logo */}
        <img src="/logo.svg" alt="Canso Logo" />

        {/* Content Card */}
        <div className="w-full flex flex-col gap-4 items-center">
          <p
            className="text-center"
            style={{
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "28px",
              color: "#0A0A0A",
            }}
          >
            Your Session Expired
          </p>

          {/* Sign In Button */}
          <button
            onClick={onLogin}
            className="w-4/5 flex items-center justify-center cursor-pointer"
            style={{
              padding: "12px 16px",
              borderRadius: "8px",
              background: "linear-gradient(180deg, #788AF7 0%, #3551F3 100%)",
              boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              color: "white",
              fontSize: "14px",
              fontWeight: 500,
              height: '35px',
              border: "none",
            }}
          >
            Sign In Again
          </button>

          {/* Footer text */}
          <p
            className="text-center"
            style={{
              fontSize: "12px",
              color: "#737373",
            }}
          >
            If this issue persists, please contact support
          </p>
        </div>
      </div>
    </div>
  );
}
